import { CredifyClass } from "./common";
import {
  BaseResponse, MessageInfo, Terms,
} from "./type";
import { validate as isValidUUID } from "uuid";
import { BNPLConsumerApiFactory, BNPLProviderApiFactory } from "@credify/api-docs/apiClients/integration-v2";
import { OrderCreationRequest, OrderCompletionRequest, OrderRevertingRequest } from "@credify/api-docs/apiClients/integration-v2";
import { handleAPIConfiguration } from "./utils";

export class Bnpl extends CredifyClass {
  /**
   * DEPRECATED
   * Create a Bnpl order
   * @param referenceId - ID of the order
   * @param totalAmount - Total amount of the order
   * @param orderLines - Order's orderLines
   * @param paymentRecipient - The bank account's information of the payment recipient
   * @returns order object
   */
  // public async createOrder(
  //   referenceId: string,
  //   totalAmount: FiatCurrency,
  //   orderLines: OrderLine[],
  //   paymentRecipient: PaymentRecipient
  // ): Promise<OrderInfo> {
  //   orderLines = camelize(orderLines);
  //   for (const o of orderLines) {
  //     if (o.unitPrice) {
  //       o.unitPrice = validateFiatCurrencyObject(o.unitPrice);
  //     }
  //     if (o.subtotal) {
  //       o.subtotal = validateFiatCurrencyObject(o.subtotal);
  //     }
  //   }

  //   const payload = {
  //     referenceId,
  //     totalAmount: validateFiatCurrencyObject(totalAmount),
  //     orderLines,
  //     paymentRecipient,
  //   };

  //   try {
  //     const res = await this.apiClient.post<GetOrderResponse>(
  //       `v1/integration/bnpl-consumers/orders`,
  //       decamelize(payload)
  //     );

  //     if (!res.data?.data) {
  //       throw new Error("Unexpected object");
  //     }
  //     return res.data.data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  /**
   * DEPRECATED
   * Get Bnpl orders
   * @param credifyId - CredifyId of the user
   * @returns List of orders associated with the CredifyId
   */
  // public async getOrders(credifyId: string): Promise<OrderInfo[]> {
  //   if (!credifyId) {
  //     throw new Error("The CredifyId must be provided");
  //   }

  //   if (!isValidUUID(credifyId)) {
  //     throw new Error("The CredifyId must be in an UUID format");
  //   }

  //   try {
  //     const res = await this.apiClient.get<GetOrdersResponse>(
  //       `v1/integration/bnpl-consumers/orders?credify_id=${credifyId}`
  //     );

  //     if (!res.data?.data?.orders) {
  //       throw new Error("Unexpected object");
  //     }
  //     return res.data.data.orders;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  /**
   * Gets order's information
   * @param orderId - Id of the Order
   * @returns order object
   */
  public async getOrder(orderId: string): Promise<OrderCreationRequest> {
    if (!orderId) {
      throw new Error("ID should not be blank");
    }

    if (!isValidUUID(orderId)) {
      throw new Error("The order id must be in an UUID format");
    }

    try {
      const configuration = handleAPIConfiguration(this.config.mode)
      const client = BNPLProviderApiFactory(configuration, "", this.apiClient.instance as any)
      const res = await client.retrieveOrder(orderId)

      if (!res?.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /**
   * Acknowledge the bnpl order
   * @param transactionId - ID of the transaction
   * @param orderId - ID of the order
   */
  public async acknowledgeOrder(transactionId: string, orderId: string): Promise<any> {
    try {
      const res = await this.apiClient.post<BaseResponse>(
        `v2/integration/bnpl-provider/orders/${orderId}/acknowledge`,
        {
          txn: transactionId
        }
      );

      if (!res.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /**
   * Approve the bnpl order
   * @param orderId - ID of the order
   * @param messageInfo - Notification information
   */
  public async approveOrder(orderId: string, messageInfo: MessageInfo): Promise<any> {
    try {
      const res = await this.apiClient.post<BaseResponse>(
        `v2/integration/bnpl-provider/orders/${orderId}/approve`,
        { messageInfo }
      );

      if (!res.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /**
   * Complete the bnpl signing
   * @param orderId - ID of the order
   * @param terms - Terms of the order put into a contract
   */
  public async completeSigning(orderId: string, terms: Terms): Promise<any> {
    try {
      const res = await this.apiClient.post<BaseResponse>(
        `v2/integration/bnpl-provider/orders/${orderId}/sign`,
        { ...terms }
      );

      if (!res.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }


  /**
   * Complete the bnpl order
   * @param orderId - Id of the Order
   * @param valueDate - The date when the contract begins to be effective.
   */
  public async completeOrder(
    orderId: string,
    valueDate: string
  ): Promise<any> {
    if (!orderId) {
      throw new Error("ID should not be blank");
    }

    if (!isValidUUID(orderId)) {
      throw new Error("The order id must be in an UUID format");
    }

    try {
      const configuration = handleAPIConfiguration(this.config.mode)
      const client = BNPLProviderApiFactory(configuration, "", this.apiClient.instance as any)
      const request = { valueDate } as OrderCompletionRequest
      const res = await client.completeBnplOrder(orderId, request)

      if (!res.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /**
   * Revert the BNPL payment
   * @param orderId - Id of the Order
   * @param failedReason - failed reason
   */
  public async revertPayment(orderId: string, failedReason: string): Promise<any> {
    if (!orderId) {
      throw new Error("ID should not be blank");
    }

    if (!isValidUUID(orderId)) {
      throw new Error("The order id must be in an UUID format");
    }

    if (!failedReason) {
      throw new Error("failed reason should not be blank");
    }
    try {
      const configuration = handleAPIConfiguration(this.config.mode)
      const client = BNPLConsumerApiFactory(configuration, "", this.apiClient.instance as any)
      const request = { failedReason } as OrderRevertingRequest
      const res = await client.revertBnplOrder(orderId, request)

      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /**
   * Disbursement
   * @param orderId - Id of the Order
   */
  public async disbursement(orderId: string): Promise<any> {
    if (!orderId) {
      throw new Error("ID should not be blank");
    }

    if (!isValidUUID(orderId)) {
      throw new Error("The order id must be in an UUID format");
    }

    try {
      const configuration = handleAPIConfiguration(this.config.mode)
      const client = BNPLConsumerApiFactory(configuration, "", this.apiClient.instance as any)
      const res = await client.disburseBnplOrder(orderId)

      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /**
   * get order detail
   * @param orderId - order id
   */
   public async getOrderDetail(
    orderId: string,
  ): Promise<any> {
    if (!orderId) {
      throw new Error("The order id must not be blank")
    }
    if (!isValidUUID(orderId)) {
      throw new Error("The order id must be in an UUID format");
    }

    try {
      const res = await this.apiClient.get<BaseResponse>(
        `v1/bnpl-consumer/orders/${orderId}`,
      );

      if (!res.data?.data) {
        throw new Error("get order detail - error");
      }
      return res.data.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
